import format from 'date-fns/format';

import { GET_SESSIONS_SUCCESS, GET_SESSIONS_FAIL } from '../../../actions/sessions';

import { handleError, isSuccess } from '../../../../fetch_helpers/post_helpers';

import { SetSessions } from '../../../database/helpers';

import FetchLocalSessions from './fetch_local_sessions';

import { CreateAPI, CreateKey, ProcessSessions, StoreSessions } from './processors';

// const createAction = items => ({ type: GET_SESSIONS_SUCCESS, items });

// const getSuccessHandler = (next, date) => responseData => {
//   const action = createAction(responseData[date]);
//   return next(action);
// };

export default ({ db, currentStore }) => {
  // const { db, currentStore } = dataStore;
  const setSessions = SetSessions(db, currentStore);
  const localSessions = FetchLocalSessions(db, currentStore);
  return async ({ getState }, next, { date }) => {
    const sessions = await localSessions(date);
    if (sessions) {
      return next({
        date,
        items: sessions,
        type: GET_SESSIONS_SUCCESS,
      });
    }

    const state = getState();
    const errorMessage = handleError(next, GET_SESSIONS_FAIL);
    const key = format(date, 'YYYY-MM-DD');

    try {
      const response = await fetch(CreateAPI(state.sessions.url, date));
      const res = await response.json();
      if ((isSuccess(response) && Object.entries(res).length > 0) || res.length > 0) {
        const items = ProcessSessions(res);
        // console.log('items', items);
        StoreSessions(setSessions, items);
        return next({ type: GET_SESSIONS_SUCCESS, items: items[key], date });
      }

      if (isSuccess(response)) {
        // console.log('no items');
        await setSessions([], date);
        return next({ type: GET_SESSIONS_SUCCESS, items: [], date });
      }

      // Failure
      return errorMessage(res);
    } catch (error) {
      return errorMessage(error);
    }
  };
};
